import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-history_enchart",
  "use": "icon-history_enchart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-history_enchart\"><path d=\"M214.9 809V192h-46v663h663.2v-46z\" p-id=\"5122\" fill=\"#3197FB\" /><path d=\"M297 576.3h46v191.8h-46zM425 512.4h46v255.7h-46zM553 478.2h46V768h-46zM681 384h46v384h-46z\" p-id=\"5123\" fill=\"#3197FB\" /><path d=\"M455.9 349.6l122.2 61.2 205.5-145.7v76.7h46V195.3H683v46h54.6L574 357.3l-133.9-67-139.3 209.3 38.3 25.5z\" p-id=\"5124\" fill=\"#3197FB\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol